const FrenchTranslations = {
    common: {
        appName: "ShareYourStream",
        reducedAppName: "SyS"
    }
};
  
export default FrenchTranslations;
  